/**
 * @fileoverview gRPC-Web generated client stub for acompanha.tutorial_videos.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/tutorial_videos/v1/tutorial_videos.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.tutorial_videos = {};
proto.acompanha.tutorial_videos.v1 = require('./tutorial_videos_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest,
 *   !proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse>}
 */
const methodDescriptor_TutorialVideosService_ListTutorialVideos = new grpc.web.MethodDescriptor(
  '/acompanha.tutorial_videos.v1.TutorialVideosService/ListTutorialVideos',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest,
  proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse,
  /**
   * @param {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServiceClient.prototype.listTutorialVideos =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/ListTutorialVideos',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_ListTutorialVideos,
      callback);
};


/**
 * @param {!proto.acompanha.tutorial_videos.v1.ListTutorialVideosRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.tutorial_videos.v1.ListTutorialVideosResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServicePromiseClient.prototype.listTutorialVideos =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/ListTutorialVideos',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_ListTutorialVideos);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest,
 *   !proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse>}
 */
const methodDescriptor_TutorialVideosService_GetTutorialVideo = new grpc.web.MethodDescriptor(
  '/acompanha.tutorial_videos.v1.TutorialVideosService/GetTutorialVideo',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest,
  proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse,
  /**
   * @param {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServiceClient.prototype.getTutorialVideo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/GetTutorialVideo',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_GetTutorialVideo,
      callback);
};


/**
 * @param {!proto.acompanha.tutorial_videos.v1.GetTutorialVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.tutorial_videos.v1.GetTutorialVideoResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServicePromiseClient.prototype.getTutorialVideo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/GetTutorialVideo',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_GetTutorialVideo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest,
 *   !proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse>}
 */
const methodDescriptor_TutorialVideosService_CreateTutorialVideo = new grpc.web.MethodDescriptor(
  '/acompanha.tutorial_videos.v1.TutorialVideosService/CreateTutorialVideo',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest,
  proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse,
  /**
   * @param {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServiceClient.prototype.createTutorialVideo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/CreateTutorialVideo',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_CreateTutorialVideo,
      callback);
};


/**
 * @param {!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.tutorial_videos.v1.CreateTutorialVideoResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServicePromiseClient.prototype.createTutorialVideo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/CreateTutorialVideo',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_CreateTutorialVideo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest,
 *   !proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse>}
 */
const methodDescriptor_TutorialVideosService_UpdateTutorialVideo = new grpc.web.MethodDescriptor(
  '/acompanha.tutorial_videos.v1.TutorialVideosService/UpdateTutorialVideo',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest,
  proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse,
  /**
   * @param {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServiceClient.prototype.updateTutorialVideo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/UpdateTutorialVideo',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_UpdateTutorialVideo,
      callback);
};


/**
 * @param {!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.tutorial_videos.v1.UpdateTutorialVideoResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServicePromiseClient.prototype.updateTutorialVideo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/UpdateTutorialVideo',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_UpdateTutorialVideo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest,
 *   !proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse>}
 */
const methodDescriptor_TutorialVideosService_ReorderTutorialVideos = new grpc.web.MethodDescriptor(
  '/acompanha.tutorial_videos.v1.TutorialVideosService/ReorderTutorialVideos',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest,
  proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse,
  /**
   * @param {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServiceClient.prototype.reorderTutorialVideos =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/ReorderTutorialVideos',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_ReorderTutorialVideos,
      callback);
};


/**
 * @param {!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.tutorial_videos.v1.ReorderTutorialVideosResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServicePromiseClient.prototype.reorderTutorialVideos =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/ReorderTutorialVideos',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_ReorderTutorialVideos);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_TutorialVideosService_DeleteTutorialVideo = new grpc.web.MethodDescriptor(
  '/acompanha.tutorial_videos.v1.TutorialVideosService/DeleteTutorialVideo',
  grpc.web.MethodType.UNARY,
  proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServiceClient.prototype.deleteTutorialVideo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/DeleteTutorialVideo',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_DeleteTutorialVideo,
      callback);
};


/**
 * @param {!proto.acompanha.tutorial_videos.v1.DeleteTutorialVideoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.tutorial_videos.v1.TutorialVideosServicePromiseClient.prototype.deleteTutorialVideo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.tutorial_videos.v1.TutorialVideosService/DeleteTutorialVideo',
      request,
      metadata || {},
      methodDescriptor_TutorialVideosService_DeleteTutorialVideo);
};


module.exports = proto.acompanha.tutorial_videos.v1;

